import {
  Configuration,
  LogLevel,
  PublicClientApplication
} from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.VUE_APP_AD_CLIENT_ID || '',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: process.env.VUE_APP_AD_REDIRECT_URI || ''
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        console.log(message);
      },
      logLevel: LogLevel.Info
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read', 'Files.ReadWrite']
};

export const msalInstance = new PublicClientApplication(msalConfig);
